import * as React from "react";
import { styled } from "@mui/material/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import {
  Card,
  CardActions,
  CardContent,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";
import { Padding } from "@mui/icons-material";

interface StyledTabsProps {
  children?: React.ReactNode;
  value: number;
  onChange: (event: React.SyntheticEvent, newValue: number) => void;
}

const StyledTabs = styled((props: StyledTabsProps) => (
  <Tabs
    {...props}
    TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
  />
))({
  "& .MuiTabs-indicator": {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",

    // padding: "12px",
  },
  "& .MuiTabs-indicatorSpan": {
    width: "100%",
    backgroundColor: "black",
    Padding: "0px",
  },
  borderBottom: "2px solid #dad9da",
  boxSizing: "inherit",
  // "& .MuiTabs-indicator": {
  //   backgroundColor: "#1890ff",
  // },
  "& .MuiTabs-scroller": {
    overflow: "scroll !important",
    "&::-webkit-scrollbar": {
      display: "none !important",
    },
    "-ms-overflow-style": "none",
    scrollbarWidth: "none",
  },
});

interface StyledTabProps {
  label: string;
}

const StyledTab = styled((props: StyledTabProps) => (
  <Tab disableRipple {...props} />
))(({ theme }) => ({
  textTransform: "none",
  fontWeight: theme.typography.fontWeightBold,
  fontSize: theme.typography.pxToRem(20),
  marginRight: theme.spacing(1),
  color: "gray",
  "&.Mui-selected": {
    color: "black",
    boxShadow: "0 4px #0a0a0a",
  },
  "&.Mui-focusVisible": {
    backgroundColor: "black",
    boxShadow: "0 4px #0a0a0a",
  },
}));
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 2 }}>{children}</Box>}
    </div>
  );
}
function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

// export default function CustomizedTabs();
const ArtworkTab: React.FC<{
  description: string[];
  year: number;
  subjects: string[];
  styles: string[];
  mediums: string[];
  mediumsDetail: string;
  sizes: number[];
}> = (props) => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box>
        <StyledTabs
          value={value}
          onChange={handleChange}
          aria-label="styled tabs example"
          sx={{ overflow: "scroll" }}
        >
          <StyledTab label="Information" {...a11yProps(0)} />
          <StyledTab label="Packaging & Delivery" {...a11yProps(1)} />
        </StyledTabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        {props.description.map((item) => (
          <Typography>{item}</Typography>
        ))}
        <br />
        <Typography sx={{ fontWeight: "bolder", display: "inline" }}>
          Sizes:
        </Typography>{" "}
        {props.sizes[0]} x {props.sizes[1]} x {props.sizes[2]} cm
        <br />
        <Typography sx={{ fontWeight: "bolder", display: "inline" }}>
          Year Created:
        </Typography>{" "}
        {props.year}
        <br />
        <Typography
          sx={{
            display: "inline",
            fontWeight: "bold",
          }}
        >
          {props.mediumsDetail}
        </Typography>
        <br /> <br />
        <Typography sx={{ fontWeight: "bolder" }}>Theme:</Typography>
        {props.subjects.map((subject: string, i) => (
          <React.Fragment>
            <Link to={`/shop?theme=${subject}`}>
              <Typography
                sx={{
                  display: "inline",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                {subject}
              </Typography>
            </Link>
            {i < props.subjects.length - 1 ? ", " : ""}
          </React.Fragment>
        ))}
        <br />
        <br />
        <Typography sx={{ fontWeight: "bolder" }}>Styles:</Typography>
        {props.styles.map((style: string, i) => (
          <React.Fragment>
            <Link to={`/shop?style=${style}`}>
              <Typography
                sx={{
                  display: "inline",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                {style}
              </Typography>
            </Link>
            {i < props.styles.length - 1 ? ", " : ""}
          </React.Fragment>
        ))}
        <br />
        <br /> <Typography sx={{ fontWeight: "bolder" }}>Medium:</Typography>
        {props.mediums.map((medium: string, i) => (
          <React.Fragment>
            <Link to={`/shop?medium=${medium}`}>
              <Typography
                sx={{
                  display: "inline",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                {medium}
              </Typography>
            </Link>
            {i < props.mediums.length - 1 ? ", " : ""}
          </React.Fragment>
        ))}
        <br />
        <br />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <Typography sx={{ fontWeight: "bolder" }}>Delivery Time:</Typography>
        <Typography>
          Typically 5-7 business days for domestic shipments, 10-14 business
          days for international shipments.
        </Typography>
        <br />
        <Typography sx={{ fontWeight: "bolder" }}>Returns:</Typography>
        <Typography>
          14-day return policy. Visit our Return Policy section for more
          information.
        </Typography>
      </CustomTabPanel>
    </Box>
  );
};
export default ArtworkTab;
